const EnTranslation: Record<string, string> = {
  reviews: 'Reviews',
  requests: 'Requests',
  staff: 'Staff',
  products: 'Products',
  settings: 'Settings',
  english: 'English',
  japanese: 'Japanese',
  chineseTw: 'Chinsese (Traditional)',
  chineseCn: 'Chinsese (Simplified)',
  korean: 'Korean',

  //reviews
  title: 'Title',
  content: 'Content',
  name: 'Name',
  email: 'Email',
  product: 'Product',
  ratings: 'Ratings',
  verified: 'Verified',
  createdAt: 'Created At',
  publication: 'Publication',
  publish: 'Publish',
  unpublish: 'Unpublish',
  notVerified: 'Not Verified',
  orderId: 'Order ID',

  //product
  productName: 'Product Name',
  shopifyId: 'Shopify ID',
  linkedProductReviews: 'Linked Product Reviews',

  //search
  removeFilters: 'Remove Filters',
  search: 'Search',
  searchScope: 'Search Scope',
  chooseScope: 'Plase choose a search scope',

  //review request
  delete: 'Delete',
  deleteNumberRequest: 'Delete {{number}} request(s)?',
  deletedNotReversible: 'This action is not reversible',
  orderNumber: 'Order Number',
  status: 'Status',
  sentAt: 'Sent At',
  reviewedAt: 'Reviewed At',
  manuallySendEmailTo: 'Manually send review email to {{email}}?',
  sendEmailManually: 'Send Manually',
  sendEmail: 'Send Email',
  successfullySentEmailTo: 'Sucessfully sent review email to {{email}}',
  failedToSentEmailTo: 'Failed to sent review email to {{email}}',

  //dashboard
  dashboard: 'Dashboard',
  reviewRatingTopNumber: 'Top {{value}} Highest Average Ratings',
  averageRatings: 'Average Ratings',
  totalReviews: 'Total Reviews',

  //general
  cancel: 'Cancel',
  confirmation: 'Confirmation',
  confirm: 'Confirm',
  confirmDelete: 'Confirm Delete',
  deletedCount: '{{number}} row(s) of data has been deleted',
  deleteFail: 'Deletion Fail',
  moreActions: 'More Actions',

  //create review
  createReview: 'Create Review',
  createNewReview: 'Create New Review',
  selectProduct: 'Select Product',
  score: 'Score',
  reviewerEmail: 'Reviewer Email',
  reviewerName: 'Reviewer Name',
  reviewTitle: 'Review Title',
  reviewContent: 'Review Content',
  create: 'Create',
  creatingReview: 'Creating Review...',
  reviewCreatedSuccess: 'Review created successfully',
  reviewCreateError: 'Failed to create review',
}

export default EnTranslation
